// components
import ComponentsRender from '@/components/ComponentsRender';

// constants
import { COMPONENTS } from '@/components/components';

const LightBlock = ({
  roundTop,
  roundBottom,
  moveTop,
  lightBlockContent: content,
  lightBlockLights: lights,
  lightBlockBackground: background
}) => {
  const classNameRounded = `${roundTop ? 'rounded-t-[32px]' : ''} ${roundBottom ? 'rounded-b-[32px]' : ''}`.trim();
  const classNameMoveTop = `${moveTop ? 'mt-[-32px]' : ''}`;

  let classNameBackground = 'bg-transparent';
  if (background === 'black_grey') {
    classNameBackground = 'bg-gradient-to-b from-[var(--color-black)] from-65% to-[var(--color-grey-950)] to-90%';
  } else if (background === 'grey') {
    classNameBackground = 'bg-grey-950';
  }

  return (
    <section
      data-variant="light"
      className={`relative overflow-hidden ${classNameBackground} ${classNameMoveTop}`.trim()}
    >
      <div className={`bg-white pt-8 pb-8 text-black ${classNameRounded}`.trim()}>
        <div className="relative z-2">
          {(content || []).map((component) => (
            <ComponentsRender key={`${component.id}_${component.__typename}`} type={COMPONENTS} component={component} />
          ))}
        </div>

        {lights === 'variant1' || lights === 't_224px_r_10p_purple_t_40p_l_12p_green_b_40px_r_15p_blue' ? (
          <>
            <div className="gpu-render absolute top-56 right-[10%] z-1 h-[402px] w-[402px] transform-gpu rounded-full bg-purple-500 opacity-40 blur-[150px]" />
            <div className="gpu-render absolute right-[15%] bottom-10 z-1 h-[370px] w-[370px] transform-gpu rounded-full bg-blue-500 opacity-40 blur-[150px]" />
            <div className="gpu-render absolute top-[40%] left-[12%] z-1 h-[405px] w-[405px] transform-gpu rounded-full bg-green-500 opacity-40 blur-[150px]" />
          </>
        ) : lights === 'variant2' ||
          lights === 't_380px_r_n200px_purple_t_580px_l_n200px_blue_b_580px_r_n200px_yellow' ? (
          <>
            <div className="gpu-render absolute top-[380px] -right-[200px] h-[275px] w-[251px] bg-purple-500 blur-[200px] lg:top-[250px] lg:right-0" />
            <div className="gpu-render absolute top-[580px] -left-[200px] h-[275px] w-[251px] bg-blue-300 blur-[200px] lg:top-[650px] lg:left-0" />
            <div className="gpu-render absolute -right-[200px] bottom-[580px] h-[475px] w-[251px] bg-yellow-500 blur-[200px] lg:-right-[100px] lg:bottom-[400px]" />
          </>
        ) : lights === 'variant3' || lights === 'b_100px_l_0px_orange_b_700px_r_0px_purple' ? (
          <>
            <div className="gpu-render bg-brand-500 absolute bottom-[100px] -left-0 h-[140px] w-[140px] blur-[150px] lg:-right-[20px] lg:h-[180px] lg:w-[180px]" />
            <div className="gpu-render absolute -right-0 bottom-[700px] h-[140px] w-[140px] bg-purple-500 blur-[200px] lg:-right-[20px] lg:h-[250px] lg:w-[250px]" />
          </>
        ) : lights === 'variant4' ||
          lights === 't_800px_l_200px_purple_t_30p_r_15p_green_b_100px_l_0px_green_b_700px_r_0px_purple' ? (
          <>
            <div className="gpu-render absolute top-[800px] left-[200px] h-[140px] w-[140px] bg-purple-500 blur-[200px] lg:-right-[20px] lg:h-[250px] lg:w-[250px]" />
            <div className="gpu-render bg-brand-500 absolute top-[30%] right-[15%] h-[140px] w-[140px] blur-[150px] lg:h-[180px] lg:w-[180px]" />
            <div className="gpu-render bg-brand-500 absolute bottom-[100px] -left-0 h-[140px] w-[140px] blur-[150px] lg:-right-[20px] lg:h-[180px] lg:w-[180px]" />
            <div className="gpu-render absolute -right-0 bottom-[700px] h-[140px] w-[140px] bg-purple-500 blur-[200px] lg:-right-[20px] lg:h-[250px] lg:w-[250px]" />
          </>
        ) : lights === 'variant5' || lights === 't_224px_r_10p_purple' ? (
          <>
            <div className="gpu-render absolute top-56 right-[10%] z-1 h-[402px] w-[402px] transform-gpu rounded-full bg-purple-500 opacity-40 blur-[150px]" />
          </>
        ) : lights === 'variant6' || lights === 't_224px_r_10p_purple_t_40p_l_15p_orange' ? (
          <>
            <div className="gpu-render absolute top-56 right-[10%] z-1 h-[402px] w-[402px] transform-gpu rounded-full bg-purple-500 opacity-40 blur-[150px]" />
            <div className="gpu-render bg-brand-500 absolute top-[40%] left-[15%] h-[140px] w-[140px] blur-[150px] lg:h-[180px] lg:w-[180px]" />
          </>
        ) : lights === 'variant7' || lights === 't_312px_l_15p_blue' ? (
          <>
            <div className="gpu-render absolute top-78 left-[15%] z-1 h-[402px] w-[402px] transform-gpu rounded-full bg-blue-500 opacity-40 blur-[150px]" />
          </>
        ) : lights === 'variant8' || lights === 't_312px_l_15p_green' ? (
          <>
            <div className="gpu-render absolute top-78 left-[15%] z-1 h-[402px] w-[402px] transform-gpu rounded-full bg-green-500 opacity-40 blur-[150px]" />
          </>
        ) : null}
      </div>
    </section>
  );
};
export default LightBlock;
